var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataScrapingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04102 13.4479V10.9678H4.52117",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3404 5.81445C13.9575 9.09613 11.9493 12.3495 8.67045 13.2281C6.16098 13.9005 3.60048 12.996 2.04102 11.122",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.661877 8.18478C0.0447739 4.9031 2.05302 1.64968 5.33181 0.771129C7.84111 0.0987638 10.4014 1.0031 11.9609 2.87684",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9606 0.551758V3.03191H9.48047",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08937 7.33336C3.73844 7.27231 3.73844 6.76853 4.08937 6.70748C5.36073 6.4863 6.37192 5.51793 6.64787 4.25733L6.66902 4.1607C6.74495 3.81387 7.23879 3.81171 7.31774 4.15786L7.34343 4.27047C7.62959 5.52513 8.64105 6.48531 9.90888 6.70588C10.2616 6.76725 10.2616 7.27359 9.90888 7.33495C8.64105 7.55552 7.62959 8.51571 7.34343 9.77036L7.31774 9.88297C7.23879 10.2292 6.74495 10.227 6.66902 9.88015L6.64787 9.78351C6.37192 8.5229 5.36073 7.55454 4.08937 7.33336Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScrapingIcon);
export default __webpack_public_path__ + "static/media/data_scraping_icon.0a5e4a371e71fe0ad89398ca5a4ba01e.svg";
export { ForwardRef as ReactComponent };